import { createReducer } from '@reduxjs/toolkit';

import { initialState } from './state';
import {
    clearAllAction,
    clearErrorsAction,
    getAllUpcomingEvents,
} from './actions';
import { ApiResponse } from '../../models';

export const reducer = createReducer(initialState, builder =>
    builder
        .addCase(getAllUpcomingEvents.pending, state => {
            return { ...state, isFetching: true, errorMessage: undefined };
        })
        .addCase(getAllUpcomingEvents.fulfilled, (state, action) => {
            const { events } = action.payload.results;
            return {
                ...state,
                isFetching: false,
                items: events || [],
                lastFetchedCustomerId: action.meta.arg.customerId,
            };
        })
        .addCase(getAllUpcomingEvents.rejected, (state, action) => {
            const { errorMessage } = (action.payload as ApiResponse) || {};
            return { ...state, isFetching: false, errorMessage };
        })
        .addCase(clearErrorsAction.fulfilled, state => ({ ...state, errorMessage: undefined }))
        .addCase(clearAllAction.fulfilled, () => ({ ...initialState }))
);
